export default {
    name: "FormElement",

    props: {
        value: [String, Number],
        errors: Array,
        persistAction: String,
        name: String,
    },

    data: function () {
        return {
            id: _.uniqueId(),
            saving: false,
            saved: false,
        }
    },

    methods: {
        /**
         * Sauve la valeur du champ en base de donnée si les attibuts persistAction et name sont définis
         */
        persist: function (value) {
            if (this.persistAction && this.name) {
                let params = {}
                params[this.name] = value
                this.saved = false
                this.saving = true

                axios.patch(this.persistAction, params)
                    .then(() => {
                        this.saved = true
                        this.saving = false
                    })
                    .catch(this.showError)
            }
        },

        /**
         * Display l'erreur
         */
        showError: function (error) {
            this.saving = false
            this.saved = false

            if (error.response.errors) {
                this.errors = error.response.errors[this.name]
            } else {
                this.$notify('Une erreur est survenue lors de la mise à jour.')
            }
        }
    }
}
